import * as ambassadorWixStoresCatalogV3Brand from './stores-catalog-v3-brand-brands-v-3.http.js';
import * as ambassadorWixStoresCatalogV3BrandTypes from './stores-catalog-v3-brand-brands-v-3.types.js';
import * as ambassadorWixStoresCatalogV3BrandUniversalTypes from './stores-catalog-v3-brand-brands-v-3.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createBrand(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3BrandUniversalTypes.CreateBrandRequest,
  ambassadorWixStoresCatalogV3BrandTypes.CreateBrandRequest,
  ambassadorWixStoresCatalogV3BrandUniversalTypes.CreateBrandResponse,
  ambassadorWixStoresCatalogV3BrandTypes.CreateBrandResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Brand.createBrand(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/brands',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getBrand(): __PublicMethodMetaInfo<
  'GET',
  { brandId: string },
  ambassadorWixStoresCatalogV3BrandUniversalTypes.GetBrandRequest,
  ambassadorWixStoresCatalogV3BrandTypes.GetBrandRequest,
  ambassadorWixStoresCatalogV3BrandUniversalTypes.GetBrandResponse,
  ambassadorWixStoresCatalogV3BrandTypes.GetBrandResponse
> {
  const payload = { brandId: ':brandId' } as any;

  const getRequestOptions = ambassadorWixStoresCatalogV3Brand.getBrand(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/brands/{brandId}',
    pathParams: { brandId: 'brandId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateBrand(): __PublicMethodMetaInfo<
  'PATCH',
  { brandId: string },
  ambassadorWixStoresCatalogV3BrandUniversalTypes.UpdateBrandRequest,
  ambassadorWixStoresCatalogV3BrandTypes.UpdateBrandRequest,
  ambassadorWixStoresCatalogV3BrandUniversalTypes.UpdateBrandResponse,
  ambassadorWixStoresCatalogV3BrandTypes.UpdateBrandResponse
> {
  const payload = { brand: { id: ':brandId' } } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Brand.updateBrand(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/brands/{brand.id}',
    pathParams: { brandId: 'brandId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteBrand(): __PublicMethodMetaInfo<
  'DELETE',
  { brandId: string },
  ambassadorWixStoresCatalogV3BrandUniversalTypes.DeleteBrandRequest,
  ambassadorWixStoresCatalogV3BrandTypes.DeleteBrandRequest,
  ambassadorWixStoresCatalogV3BrandUniversalTypes.DeleteBrandResponse,
  ambassadorWixStoresCatalogV3BrandTypes.DeleteBrandResponse
> {
  const payload = { brandId: ':brandId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Brand.deleteBrand(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/brands/{brandId}',
    pathParams: { brandId: 'brandId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryBrands(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixStoresCatalogV3BrandUniversalTypes.QueryBrandsRequest,
  ambassadorWixStoresCatalogV3BrandTypes.QueryBrandsRequest,
  ambassadorWixStoresCatalogV3BrandUniversalTypes.QueryBrandsResponse,
  ambassadorWixStoresCatalogV3BrandTypes.QueryBrandsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Brand.queryBrands(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/brands/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateBrands(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3BrandUniversalTypes.BulkCreateBrandsRequest,
  ambassadorWixStoresCatalogV3BrandTypes.BulkCreateBrandsRequest,
  ambassadorWixStoresCatalogV3BrandUniversalTypes.BulkCreateBrandsResponse,
  ambassadorWixStoresCatalogV3BrandTypes.BulkCreateBrandsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Brand.bulkCreateBrands(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/brands/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateBrands(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3BrandUniversalTypes.BulkUpdateBrandsRequest,
  ambassadorWixStoresCatalogV3BrandTypes.BulkUpdateBrandsRequest,
  ambassadorWixStoresCatalogV3BrandUniversalTypes.BulkUpdateBrandsResponse,
  ambassadorWixStoresCatalogV3BrandTypes.BulkUpdateBrandsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Brand.bulkUpdateBrands(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/brands/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOrCreateBrand(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3BrandUniversalTypes.GetOrCreateBrandRequest,
  ambassadorWixStoresCatalogV3BrandTypes.GetOrCreateBrandRequest,
  ambassadorWixStoresCatalogV3BrandUniversalTypes.GetOrCreateBrandResponse,
  ambassadorWixStoresCatalogV3BrandTypes.GetOrCreateBrandResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Brand.getOrCreateBrand(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/brands/get-or-create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkGetOrCreateBrands(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3BrandUniversalTypes.BulkGetOrCreateBrandsRequest,
  ambassadorWixStoresCatalogV3BrandTypes.BulkGetOrCreateBrandsRequest,
  ambassadorWixStoresCatalogV3BrandUniversalTypes.BulkGetOrCreateBrandsResponse,
  ambassadorWixStoresCatalogV3BrandTypes.BulkGetOrCreateBrandsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Brand.bulkGetOrCreateBrands(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/brands/get-or-create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteBrands(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3BrandUniversalTypes.BulkDeleteBrandsRequest,
  ambassadorWixStoresCatalogV3BrandTypes.BulkDeleteBrandsRequest,
  ambassadorWixStoresCatalogV3BrandUniversalTypes.BulkDeleteBrandsResponse,
  ambassadorWixStoresCatalogV3BrandTypes.BulkDeleteBrandsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3Brand.bulkDeleteBrands(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/brands/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Brand as BrandOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateBrandRequest as CreateBrandRequestOriginal,
  CreateBrandResponse as CreateBrandResponseOriginal,
  GetBrandRequest as GetBrandRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  GetBrandResponse as GetBrandResponseOriginal,
  UpdateBrandRequest as UpdateBrandRequestOriginal,
  UpdateBrandResponse as UpdateBrandResponseOriginal,
  DeleteBrandRequest as DeleteBrandRequestOriginal,
  DeleteBrandResponse as DeleteBrandResponseOriginal,
  QueryBrandsRequest as QueryBrandsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryBrandsResponse as QueryBrandsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkCreateBrandsRequest as BulkCreateBrandsRequestOriginal,
  BulkCreateBrandsResponse as BulkCreateBrandsResponseOriginal,
  BulkBrandsResult as BulkBrandsResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateBrandsRequest as BulkUpdateBrandsRequestOriginal,
  MaskedBrand as MaskedBrandOriginal,
  BulkUpdateBrandsResponse as BulkUpdateBrandsResponseOriginal,
  GetOrCreateBrandRequest as GetOrCreateBrandRequestOriginal,
  GetOrCreateBrandResponse as GetOrCreateBrandResponseOriginal,
  BulkGetOrCreateBrandsRequest as BulkGetOrCreateBrandsRequestOriginal,
  BulkGetOrCreateBrandsResponse as BulkGetOrCreateBrandsResponseOriginal,
  BulkDeleteBrandsRequest as BulkDeleteBrandsRequestOriginal,
  BulkDeleteBrandsResponse as BulkDeleteBrandsResponseOriginal,
  BulkDeleteBrandsResponseBulkBrandsResult as BulkDeleteBrandsResponseBulkBrandsResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  RecloneSiteRequest as RecloneSiteRequestOriginal,
  RecloneSiteResponse as RecloneSiteResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateBrandValidationErrors as CreateBrandValidationErrorsOriginal,
  BulkCreateBrandsValidationErrors as BulkCreateBrandsValidationErrorsOriginal,
  GetOrCreateBrandValidationErrors as GetOrCreateBrandValidationErrorsOriginal,
} from './stores-catalog-v3-brand-brands-v-3.types.js';
